import { render, staticRenderFns } from "./BodyMeasurementItem.vue?vue&type=template&id=6f2a1cd5&scoped=true&"
import script from "./BodyMeasurementItem.vue?vue&type=script&lang=js&"
export * from "./BodyMeasurementItem.vue?vue&type=script&lang=js&"
import style0 from "./BodyMeasurementItem.vue?vue&type=style&index=0&id=6f2a1cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a1cd5",
  null
  
)

export default component.exports